/* cc-reveal — design-system scroll entry: sections fade up 12px once
   as they enter the viewport. Styles live in cc-tokens.css (.cc-reveal)
   and are gated behind prefers-reduced-motion there; this script also
   skips entirely for reduced-motion users. The hero is excluded — the
   LCP must render instantly. */

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = document.querySelectorAll('main .shopify-section:not(:first-child)');
  if (!targets.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cc-reveal--in');
          io.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.08 }
  );

  for (const el of targets) {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight) continue; // already visible on load — don't animate
    el.classList.add('cc-reveal');
    io.observe(el);
  }
})();
